"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTabIndex = exports.doTabsMatch = exports.getTabLabel = exports.getTabId = exports.swapLastRowTabWithActiveTab = exports.calcVisibleTabs = exports.isKeyboardPress = void 0;
const isKeyboardPress = (e) => e.type === 'keydown' || e.type === 'keypress' || e.type === 'keyup';
exports.isKeyboardPress = isKeyboardPress;
const calcVisibleTabs = (tabs, width = {
    totalTabsWidth: 0,
    available: 0,
    reserved: 0
}, visible = 0) => {
    let trueAvailableWidth = width.available;
    // On first recursion check if we even need to decide what is visible
    if (visible === 0) {
        if (width.totalTabsWidth <= width.available) {
            return tabs.length;
        }
        else {
            // If we know that we are going to overflow the tabs container
            // we need to reserve space for the dropdown menu.
            trueAvailableWidth =
                Math.ceil(width.available) - Math.ceil(width.reserved);
        }
    }
    const [head, ...tail] = tabs;
    if (!head || trueAvailableWidth - head < 0) {
        return Math.max(visible, 1);
    }
    return Math.max((0, exports.calcVisibleTabs)(tail, Object.assign(Object.assign({}, width), { available: trueAvailableWidth - head }), visible + 1), 1);
};
exports.calcVisibleTabs = calcVisibleTabs;
const swapLastRowTabWithActiveTab = (rowTabs, menuTabs, activeTab) => {
    const newRowTabs = [...rowTabs];
    const newMenuTabs = [...menuTabs];
    const lastTabInRow = newRowTabs[newRowTabs.length - 1];
    const activeTabIndex = newMenuTabs.findIndex((tab) => (0, exports.doTabsMatch)(tab, activeTab));
    if (activeTabIndex > -1) {
        newMenuTabs[activeTabIndex] = lastTabInRow;
    }
    newRowTabs[rowTabs.length - 1] = activeTab;
    return { newRowTabs, newMenuTabs };
};
exports.swapLastRowTabWithActiveTab = swapLastRowTabWithActiveTab;
const getTabId = (tab) => {
    return typeof tab === 'string' ? tab : tab.id;
};
exports.getTabId = getTabId;
const getTabLabel = (tab) => {
    return typeof tab === 'string' ? tab : tab.label;
};
exports.getTabLabel = getTabLabel;
const doTabsMatch = (tab1, tab2) => {
    if (!tab1 || !tab2)
        return false;
    return (0, exports.getTabId)(tab1) === (0, exports.getTabId)(tab2);
};
exports.doTabsMatch = doTabsMatch;
const getTabIndex = (activeTab, isSelected, tabListIndex, renderAsNav) => {
    if (renderAsNav) {
        // when using the tab component as a nav, use the natural tab order
        return 0;
    }
    const isFirstTab = tabListIndex === 0;
    if (activeTab) {
        // If there is an active tab, and
        // if the current tab is selected, it should be focusable via keyboard.
        // Other tabs will be focusable via the keydown handler on the list.
        return isSelected ? 0 : -1;
    }
    else {
        // If there is no active tab, and
        // if the current tab is the first tab in the list, it should be focusable via keyboard.
        // Other tabs will be focusable via the keydown handler on the list.
        return isFirstTab ? 0 : -1;
    }
};
exports.getTabIndex = getTabIndex;
//# sourceMappingURL=utils.js.map